import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import PortalModel from '../../../models/portal';
import styles from './portal.module.scss';
import PortalLayer from './PortalLayer';

type Props = {
  data: PortalModel;
  current: string;
};

const Portal = ({ data, current }: Props) => {
  const sectionContainer = document.getElementById(data.sectionContainerId);
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return sectionContainer ? (
    ReactDOM.createPortal(
      <div className={styles.portal}>
        <CSSTransition
          in={current === data.id}
          timeout={200}
          unmountOnExit
          onEntered={scrollTop}
        >
          <PortalLayer
            sectionContainerId={data.sectionContainerId}
            content={data.content}
          />
        </CSSTransition>
      </div>,
      sectionContainer
    )
  ) : (
    <></>
  );
};

export default Portal;
